import { render } from "./loginpage.vue?vue&type=template&id=5928b828"
import script from "./loginpage.vue?vue&type=script&lang=js"
export * from "./loginpage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__